import React, { useState } from 'react';

import * as yup from 'yup';
import { Form, Formik } from 'formik';
import { css, cx } from '@emotion/css';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';

import { Path } from 'router/routing';
import { dikastisApi } from 'dikastis-api';
import { useQueryParams } from 'router/useDikastisRouting';
import { useToast } from 'toast/toast-context';

import AuthPage from 'auth/AuthPage';
import DktButton from 'shared/DktButton';
import DktFormField from 'shared/form/DktFormField';
import DktText from 'shared/DktText';
import FlexLayout from 'shared/FlexLayout';

const resendEmailStyle = css`
  margin-top: 40px;
`;
const emailMarginStyle = css`
  margin-top: 20px;
`;
const formStyle = css`
  display: flex;
  flex-direction: column;
`;
const fieldStyle = css`
  width: 100%;
`;

const validationSchema = yup.object().shape({
  email: yup.string().email('Email invalid').required('Is required'),
});

function ResendActivationForm({ children }) {
  const { username } = useQueryParams();
  const { addToast } = useToast();
  const history = useHistory();
  const resetPassword = useMutation(
    (form) => dikastisApi.patch(`/people/activate/${username}/resend`, form),
    {
      onError: (err) => {
        if (err?.response?.data?.message === 'Please wait before requesting again.') {
          addToast(403, 'Please wait 5 minutes before requesting again.');
        } else {
          addToast(500);
        }
      },
      onSuccess: () => {
        addToast(200, 'Check your mail box!');
        history.push(Path.SIGN_IN);
      },
    },
  );

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={validationSchema}
      onSubmit={resetPassword.mutate}
    >
      <Form className={cx(formStyle)}>{children}</Form>
    </Formik>
  );
}

export default function ResendActivation() {
  const { username } = useQueryParams();
  const [acknowledgedResend, setAcknowledgedResend] = useState(false);

  if (!acknowledgedResend) {
    console.log('not ack');
    return (
      <AuthPage>
        <DktText holder="h3">Inactive account</DktText>
        <DktText holder="p" style={emailMarginStyle}>An activation email was sent to you, please check your inbox!</DktText>
        <FlexLayout justifyContent="flex-end">
          <DktButton
            submit
            style={resendEmailStyle}
            onClick={() => setAcknowledgedResend(true)}
          >
            Resend email
          </DktButton>
        </FlexLayout>
      </AuthPage>
    );
  }

  console.log('ack');
  return (
    <AuthPage greeting={`Resend your activation email, ${username}!`}>
      <FlexLayout flexDirection="column" justifyContent="center">
        <ResendActivationForm>
          <DktFormField fieldStyle={fieldStyle} name="email" placeholder="Your e-mail address" title="Email" type="email" />
          <FlexLayout justifyContent="flex-end">
            <DktButton submit style={resendEmailStyle}>Resend email</DktButton>
          </FlexLayout>
        </ResendActivationForm>
      </FlexLayout>
    </AuthPage>
  );
}
